'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dRule$002dKind$0024 from "./presto.types$-Rule-Kind$.js";
var $p;
/** @constructor */
function $c_Lpresto_RulesTable$$anon$6() {
}
export { $c_Lpresto_RulesTable$$anon$6 as $c_Lpresto_RulesTable$$anon$6 };
$p = $c_Lpresto_RulesTable$$anon$6.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RulesTable$$anon$6;
/** @constructor */
function $h_Lpresto_RulesTable$$anon$6() {
}
export { $h_Lpresto_RulesTable$$anon$6 as $h_Lpresto_RulesTable$$anon$6 };
$h_Lpresto_RulesTable$$anon$6.prototype = $p;
$p.bh = (function(_$38) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(_$38, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$39) => _$39.ql.GV())), $j_presto$002etypes$0024$002dRule$002dKind$0024.$m_Lpresto_types$RuleKind$().cIA());
});
var $d_Lpresto_RulesTable$$anon$6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RulesTable$$anon$6, "presto.RulesTable$$anon$6", ({
  Qo: 1,
  H: 1
}));
export { $d_Lpresto_RulesTable$$anon$6 as $d_Lpresto_RulesTable$$anon$6 };
//# sourceMappingURL=presto.-Rules-Table$$anon$6.js.map
